import {
  CategoryNameSchemasType,
  FormDatePicker,
  FormInputNumber,
} from '@atlas-frontend/sdk';
import { getNumberConstraints } from './utils';
import { InputDataDimensionField } from './InputDataDimensionField';
import { InputDataEditCellProps } from './types';

export function InputDataEditable(
  props: InputDataEditCellProps & {
    categoryNames?: CategoryNameSchemasType | null;
    cellName: `${string}.${number}.${string}`;
  },
) {
  // Indicator or dimension's classifier type is number
  if (props.columnType.type === 'number') {
    const constraints = getNumberConstraints(props.columnType.decimals);

    return (
      <FormInputNumber
        autoFocus
        size="small"
        name={props.cellName}
        {...constraints}
        decimalSeparator=","
        stringFormat={true}
      />
    );
  }

  // Dimension's classifier type is date
  if (props.columnType.dataType === 'DATE') {
    return <FormDatePicker name={props.cellName} />;
  }

  return (
    <InputDataDimensionField
      name={props.cellName}
      labels={props.categoryNames}
      valueDate={props.date}
    />
  );
}
